import {
  IMPERSONATED_ZEZAM_ID_KEY,
  IMPERSONATED_ZEZAM_USER_QUERY_PARAM,
} from '@web-apps/utils-shared'

import { isRNWebView } from './rnWebView.helpers'

export const getImpersonatedZezamId = (): string | null => {
  if (typeof window === 'undefined') return null
  if (isRNWebView()) return null

  return sessionStorage.getItem(IMPERSONATED_ZEZAM_ID_KEY)
}

export const setImpersonatedZezamId = (zezamId: string): void => {
  if (typeof window === 'undefined') return
  sessionStorage.setItem(IMPERSONATED_ZEZAM_ID_KEY, zezamId)
}

export const clearImpersonatedZezamId = (): void => {
  if (typeof window === 'undefined') return
  sessionStorage.removeItem(IMPERSONATED_ZEZAM_ID_KEY)
}

export const isImpersonating = (): boolean => {
  return !!getImpersonatedZezamId()
}

export { IMPERSONATED_ZEZAM_USER_QUERY_PARAM, IMPERSONATED_ZEZAM_ID_KEY }
